import { ReactNode } from "react";
import './panel.css'

export default function Panel(props:{children: ReactNode, className?: string}){
    return  <div className={"panel" + (props.className ? " " + props.className : "")}>
        {props.children}
    </div>;
}